import { z } from 'zod';

/**
 * Authenticated user.
 *
 * Only the fields safe to expose to the frontend live here: DB primary key,
 * upstream provider profile info, and public avatar. The encrypted access
 * token stays server-side - we never ship it over the wire.
 */
export const userSchema = z.object({
  id: z.string().uuid(),
  externalUserId: z.string(),
  name: z.string(),
  email: z.string().email(),
  avatarUrl: z.string().url().nullable(),
});
export type User = z.infer<typeof userSchema>;
